import { reactive } from 'vue'
import { CapacitorUpdater } from '@capgo/capacitor-updater'
import { Router } from 'src/router'

// The reload into the new bundle lands on the app root, so the route the user
// was on is stashed here and restored on the next boot.
const RETURN_TO_KEY = 'ota:returnTo'

/**
 * Capgo OTA state shared by boot/capacitor.js (which feeds it plugin events)
 * and the full-screen OtaUpdate overlay.
 *
 * Updates are forced: the overlay cannot be dismissed and the app restarts
 * into the new bundle as soon as it has downloaded, so every device runs
 * the same version.
 *
 * status: 'idle' | 'downloading' | 'installing' | 'failed'
 */
export const otaState = reactive({
  status: 'idle',
  percent: 0,
  version: null,
  bundleId: null
})

/** Swap to the downloaded bundle; the webview reloads. */
export function restartToUpdate () {
  if (!otaState.bundleId) {
    return
  }

  localStorage.setItem(RETURN_TO_KEY, Router.currentRoute.value.fullPath)

  // set() rejects on a bad id or a failed reload. Not fatal: the plugin still
  // installs the staged bundle on next background.
  CapacitorUpdater.set({ id: otaState.bundleId })
    .catch(error => {
      localStorage.removeItem(RETURN_TO_KEY)
      console.error('CapacitorUpdater.set() failed', otaState.bundleId, error)
      otaState.status = 'failed'
    })
}

/**
 * After restarting into a new bundle, put the user back on the route they
 * were on. Awaited in boot/capacitor.js so the router's initial navigation
 * uses it instead of the root.
 */
export function restoreRouteAfterUpdate (router) {
  const path = localStorage.getItem(RETURN_TO_KEY)
  if (!path) {
    return Promise.resolve()
  }

  localStorage.removeItem(RETURN_TO_KEY)
  return router.replace(path)
}
